
  import { Component, Vue } from "vue-property-decorator";
  import LzBox from "./Box.vue";

  @Component({ components: { LzBox } })
  export default class Modal extends Vue {}
